import React, { useState, useEffect } from "react";
import api from "services/api";
import { Accordion } from "react-bootstrap";
import Translator, { __ } from "services/Translator";

function Faqs(props) {
  const [faqs, setFaqs] = useState([]);
  const getFaqs = async () => {
    props.setSpinner(true);
    var response = await api.get("/get-faqs");
    props.setSpinner(false);
    if (response.status === 200) {
      setFaqs(response.data);
    }
  };
  useEffect(() => {
    getFaqs();
  }, []);
  const accordionToggled = (lastOpenItem) => {
    if (lastOpenItem !== null) {
      lastOpenItem = parseInt(lastOpenItem);
    }
  };
  return (
    <>
      <div className="access_control_area">
        {props.heading && (
          <>
            
            <div className="commonHeadingArea">
              <div className="leftBar"></div>
              <div className="headingText">{__("FAQs")}</div>
              <div className="rightBar"></div>
            </div>
          </>
        )}

        <Accordion className="faq-modern" onSelect={accordionToggled}>
          {faqs.map((faqCategory, index) => (
            <Accordion.Item
              className="chimp-accordion faq-modern__category"
              key={index}
              eventKey={index}
            >
              <Accordion.Header
                className={"faq__question " + props.landingType}
              >
                {faqCategory.category}
                <i></i>
              </Accordion.Header>
              <Accordion.Body className="faq__answer">
                <Accordion className="childFaq faq-modern__children">
                  {faqCategory.faqs.map((faq, index2) => (
                    <Accordion.Item
                      key={index2}
                      eventKey={index2}
                      className="faq-item chimp-accordion faq-modern__question"
                    >
                      <Accordion.Header
                        className={"faq__question " + props.landingType}
                      >
                        {faq.title}
                      </Accordion.Header>
                      <Accordion.Body className="faq__answer">
                        {faq.description}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </>
  );
}

export default Faqs;
